/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2023-09-14 13:42:13
 * @LastEditTime: 2023-09-19 15:26:57
 * @LastEditors: WangYuhan
 */
/* eslint-disable camelcase */
// 引入api请求方法
import { homeList } from '@/api/home';

const state = {
  // 接口调用参数
  postParams: {
    size: 1,
    page: 20,
  },
  isLoading: true,
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '企业名称',
        prop: 'companyName',
        checked: 1,
        sortable: true,
      },
      {
        label: '实名认证',
        prop: 'realNameAudit',
        checked: 1,
        sortable: true,
      },
      {
        label: '余额',
        prop: 'balance',
        checked: 1,
        width: 120,
        sortable: true,
      },
    ],
    total: 0,
  },
  invoiceAmountData: '',
  totalAccount: '',
  showTableResult: false,
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const { data } = await homeList({ page: 1, size: 100 });
    localStorage.setItem('getGroupLen', data.length);
    context.commit('updateListData', Object.assign({}, context.state.listData, { list: data }));
  },
};

// mutations
const mutations = {
  // 更新data数据
  updateListData(state, payload) {
    state.listData = payload;
  },
  // 更新列表表头数据
  updateEditTableList(state, payload) {
    state.listData.tableHeadList = payload;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  updateShowTableResult(state, payload) {
    state.showTableResult = payload;
  },
  updateIsLoading(state, payload) {
    state.isLoading = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
